import { defineComponent, toRefs } from "vue";
export default defineComponent({
  name: "Recharge",
  props: {
    title: {
      type: String,
      default: ""
    },
    fixed: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    onBack: {
      type: Function,
      default: null
    }
  },
  setup(props) {
    const onClickLeft = () => {
      if (props.onBack) {
        props.onBack();
        return;
      }
      history.back();
    };
    return {
      ...toRefs(props),
      onClickLeft
    };
  }
});